import { HttpParams } from "@angular/common/http";

export class Objects {
  public static removeUndefined(obj: any): any {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, value]) => value != undefined)
        .map(([key, value]) => [key, value === Object(value) ? this.removeUndefined(value) : value])
    );
  }

  public static stripUndefinedParams(params: HttpParams): HttpParams {
    params.keys().forEach((key) => {
      if (params.get(key) === undefined || params.get(key) === "undefined") {
        params = params.delete(key, undefined);
      }
    });
    return params;
  }
}
